<template>
  <div class="box-content">
    <span class="filter-title">{{ $t('filter.category.label') }}</span>
    <mobile-dialog @openChange="hideFields = $event" />
    <!--<category-select></category-select>-->
    <dynamic-fields v-if="!hideFields" />
  </div>
</template>

<script>
  import MobileDialog from './MobileDialog';
  import DynamicFields from '../MainLeftFilters/LeftFilter/DynamicFields';

  export default {
    components: {
      MobileDialog,
      DynamicFields,
    },
    data() {
      return {
        hideFields: false,
      };
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Mobile/MenuFilters.vue